import { render, staticRenderFns } from "./cve_id_request.vue?vue&type=template&id=0b4a3706"
import script from "./cve_id_request.vue?vue&type=script&lang=js"
export * from "./cve_id_request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports